import React from 'react';
import { ClipboardCheck, ChartColumn, Store } from 'lucide-react';
import BrandMark from '../BrandMark';

const HIGHLIGHTS = [
    { icon: <Store />, title: 'Pisos de venta', text: 'Clientes, tiendas y rutas en un solo lugar.' },
    { icon: <ClipboardCheck />, title: 'Auditorías en campo', text: 'Capturas, precios y exhibiciones al día.' },
    { icon: <ChartColumn />, title: 'Análisis', text: 'Share of shelf, distribución y reportes listos para exportar.' }
];

/** Shelf brand mark for the public pages (login, support): sizes md = 40px, lg = 48px. */
export function AuthBrandMark({ size = 'md' }) {
    return <BrandMark size={size === 'lg' ? 48 : 40} />;
}

/**
 * Public auth shell: calm split layout. A quiet brand panel on wide screens and the form
 * (children) centered on a neutral background.
 */
export default function AuthLayout({ children }) {
    return (
        <div className="min-h-screen w-full bg-surface-50 lg:grid lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
            <aside className="hidden lg:flex flex-col justify-between border-r border-surface-200 bg-white px-12 py-10">
                <div className="flex items-center gap-3">
                    <AuthBrandMark />
                    <span className="text-lg font-semibold tracking-tight text-surface-900">Shelf</span>
                </div>

                <div className="max-w-sm">
                    <h2 className="m-0 text-2xl font-semibold tracking-tight text-surface-900 leading-snug">
                        La ejecución en punto de venta, clara y medible.
                    </h2>
                    <p className="m-0 mt-3 text-sm text-surface-500">
                        Administra tu operación de trade marketing desde el panel de Shelf.
                    </p>
                    <ul className="m-0 mt-8 p-0 list-none space-y-5">
                        {HIGHLIGHTS.map((h) => (
                            <li key={h.title} className="flex items-start gap-3">
                                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-[15px] text-primary-600">
                                    {h.icon}
                                </span>
                                <div>
                                    <div className="text-sm font-medium text-surface-900">{h.title}</div>
                                    <div className="text-sm text-surface-500">{h.text}</div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <p className="m-0 text-xs text-surface-400">Panel administrativo Shelf</p>
            </aside>

            <main className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6">{children}</main>
        </div>
    );
}
